
export const GET_CAR_SUCESS = 'car/get'
export const GET_CAR_UPDATE = 'car/update';
export const GET_CAR_ERROR = 'car/error';
export const GET_CAR_LOADING = 'car/loading';
export const GET_CAR_DELETE = 'car/delete';